'use client';

import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  FeaturedIcon,
  Icons,
} from '@commenda/kakashi';

type ActionUnavailableModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const ActionUnavailableModal = ({
  isOpen,
  onClose,
  onConfirm,
}: ActionUnavailableModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader className="border-b-0 flex flex-col gap-lg items-start">
          <FeaturedIcon
            icon={<Icons.AlertTriangle />}
            variant="warning"
            size="lg"
          />
          <div className="space-y-xs">
            <DialogTitle>This action is not available</DialogTitle>
            <p className="txt-medium-regular text-text-secondary">
              You need to have an active service in order to send an information
              request.
            </p>
          </div>
        </DialogHeader>
        <DialogFooter className="border-t-0 pt-0">
          <Button onClick={onConfirm}>Ok, I understand</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export { ActionUnavailableModal };
